<template>
  <Layout v-if="state$$?.isVisible">
    <template #body>
      <Card :title="state$$.title">
        <template #body>
          <component
            :is="state$$.component"
          ></component>
        </template>
      </Card>
    </template>
  </Layout>
</template>

<script setup>
import {
  // shallowRef,
  inject,
  onBeforeUnmount,
  onMounted,
  provide,
  reactive,
} from 'vue';

// #region STTEDRA
import {
// useImmer,
  useDev,
  useNormalizer,
} from '@sttedra_ui/framework';
// #endregion

// #region COMPONENTS COMPOSABLES
import DetailRequestViewState from './detail-request.view-state';

import Layout from '@/components/layout/Layout.vue';
import Card from '@/components/card/Card.vue';

import {useRouter} from 'vue-router';
// #endregion

// #region API
import {StatusCodes as HttpStatus} from 'http-status-codes';
import {checkTokenLapsed as checkTokenLapsedApi} from '@/api/auth/auth.api';
// #endregion

// #region Params, Ref, Reactives, Computed
const appState$$ = inject('appState$$');

const state = new DetailRequestViewState(appState$$?.detailRequest);
const state$$ = reactive(state);

const router = useRouter();
const {getObjectFilled} = useNormalizer();
// #endregion

// #region Functions
async function checkAuth() {
  if (appState$$.isLogged) {
    appState$$.setLoginApp(true);
    const isTokenValid = await checkTokenValidate();
    appState$$.setLoginApp(false);
    if (!isTokenValid) {
      appState$$.defaultStateApp();
      return;
    }
  }
}

async function checkTokenValidate() {
  const response = await checkTokenLapsedApi(appState$$?.token);
  return response?.status !== HttpStatus.OK ? false : true;
}
// #endregion

// #region Effects, Hooks
onMounted(async () => {
  try {
    state$$.isVisible = false;

    await checkAuth();

    if (appState$$.isOffline || !getObjectFilled(appState$$.detailRequest) || !getObjectFilled(state)) {
      appState$$.setLoginApp(true);
      router.push({name: `Home`});
      return;
    }

    state$$.isVisible = true;
    appState$$.setLoginApp(false);
  } catch (error) {
    useDev.error('[DetailRequest.vue] onMounted', t);
  }
});

onBeforeUnmount(() => {
  appState$$.setLoginApp(true);
  state$$.isVisible = false;
});
// #endregion

// #region Provide, Expose
provide('detailRequestState$$', state$$);
// #endregion
</script>

<style lang="scss" scoped>
@use '@/styles/vars' as *;
@use '@/styles/breakpoints' as *;
  .card-detail-request{
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: $brand__boxspace--medium * 2;
    padding: $brand__boxspace--medium * 2;
    &__icon-container{
      border-radius: $pv__br--circle;
      color: $pv__color--white;
      flex: 1;
      padding: $brand__boxspace--medium;
      width: fit-content;
      &__icon{
        @include media("<=phone") {
          font-size: $pv__dm__icon--largue;
        }
        @include media(">phone") {
          font-size: $pv__dm__icon--largue;
        }
      }
    }

    &__qr{
      & img {
        min-width: 200px;
      }
    }

    &__icon-container--approved{
      background-color: $pv__color--green-alter !important;
    }

    &__icon-container--pending{
      background-color: $pv__color--green-alter !important;
    }

    &__icon-container--incorrect{
      background-color: $pv__color--green-alter !important;
    }

    &__icon-container--without-bonification{
      background-color: $pv__color--red !important;
    }

    &__icon-container--blocked{
      background-color: $pv__color--red !important;
    }

    &__code{
      align-items: center;
      display: flex;
      flex-direction: column;
      flex:1;
      text-align: center;

      &__text{
        text-align: center;
        font-weight: bold;
        margin-top: 0.5rem;
        @include media("<=phone") {
          font-size: 1.8rem;
        }
        @include media(">phone") {
          font-size: 2.3rem;
        }
      }

      @include media("<=phone") {
        font-size: $pv__fs--large--phone;
        text-align: center;
      }
      @include media(">phone") {
        font-size: $pv__fs--large;
      }
      &__icon{
        border-radius: $pv__br--circle;
        color: $pv__color--black;
        cursor:pointer;
        margin-left: $brand__boxspace--small;
        @include media("<=phone") {
          font-size: $pv__dm__icon--largue;
        }
        @include media(">phone") {
          font-size: $pv__dm__icon--largue;
        }
        &:hover{
          color: $pv__color--green;
        }
      }
    }

    &__date-register{
      flex:1;
      text-align: left;
      @include media("<=phone") {
        font-size: $pv__fs--large--phone;
        text-align: center;
      }
      @include media(">phone") {
        font-size: $pv__fs--large;
      }
    }

    &__edit-bttn{
      &__bttn{
        width: $pv__dm__button--w-register !important;
      }
    }

    &__text{
      align-items: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      & p {
      text-align: center;
      margin-top: 0;
        @include media("<=phone") {
          font-size: $pv__fs--xlarge--phone;
        }
        @include media(">phone") {
          font-size: $pv__fs--xlarge;
        }
      }
    }
  }
</style>
